import { Category, DirectionsCar, Person } from "@mui/icons-material";

import { EntityRow } from "./entityRows";

const GLYPHS = {
  person: Person,
  vehicle: DirectionsCar,
  item: Category,
} as const;

/** The glyph an entity is known by, wherever one stands in for the word. */
export const entityIcon = (type: EntityRow["type"], fontSize: number) => {
  const Glyph = GLYPHS[type];
  return <Glyph sx={{ fontSize }} />;
};
